import lazySampleConfig from './_lazy-sample/config';
import axaGoalConfig from './axagoal/config';
import checkCoverageConfig from './check-coverage/config';
import eHubConfig from './e-hub/config';
import emmaCustomerProfileConfig from './emma-customer-profile/config';
import exploreMoreConfig from './exploremore/config';
import fanclConfig from './fancl/config';
import findMyPolicyConfig from './findMyPolicy/config';
import healthKepperConfig from './healthkeeper/config';
import homeConfig from './home/config';
import lifeConfig from './life/config';
import ebConfig from './eb/config';
import manningsConfig from './mannings/config';
import myPrivilegesConfig from './myPrivileges/config';
import neurumHealthConfig from './neurum-health/config';
import offersConfig from './offers/config';
import partnersConfig from './partners/config';
import policyListConfig from './policy-list/config';
import settingConfig from './settings/config';
import storytalerHealthConfig from './storytaler-health/config';
import teamChallengeConfig from './team-challenge/config';
import goGreenSurvey from './go-green-survey/config';
import aktivoHealthSurvey from './aktivo-health-survey/config';
import aktivoOnboardingConfig from './aktivo-onboarding/config';
import deleteAccount from './delete-account/config';
import aktivoIndividualChallenge from './aktivo-individual-challenge/config';
import generalErrorCode from './emma-general-error-code/config';
import aktivoMyWellness from './aktivo-my-wellness/config';
import senselyWidget from './sensely-widget/config';
import referralProgramme from './referral-programme/config';
import cmsConfig from './cms/config';
import programmeRegistration from './programme-registration/config';

/**
 * Register your lazy loading module configs here
 */
export default {
  preloadModules: [
    ...myPrivilegesConfig.preloadModules,
    ...emmaCustomerProfileConfig.preloadModules,
    ...axaGoalConfig.preloadModules,
  ],
  modules: [
    // ...homeConfig.modules,
    // ...healthKepperConfig.modules,
    ...axaGoalConfig.modules,
    ...emmaCustomerProfileConfig.modules,
    ...neurumHealthConfig.modules,
    ...storytalerHealthConfig.modules,
    ...lazySampleConfig.modules,
    ...exploreMoreConfig.modules,
    ...settingConfig.modules,
    ...checkCoverageConfig.modules,
    ...eHubConfig.modules,
    ...fanclConfig.modules,
    ...findMyPolicyConfig.modules,
    ...lifeConfig.modules,
    ...ebConfig.modules,
    ...manningsConfig.modules,
    ...offersConfig.modules,
    ...partnersConfig.modules,
    ...policyListConfig.modules,
    ...teamChallengeConfig.modules,
    ...goGreenSurvey.modules,
    ...aktivoIndividualChallenge.modules,
    ...aktivoHealthSurvey.modules,
    ...aktivoOnboardingConfig.modules,
    ...deleteAccount.modules,
    ...generalErrorCode.modules,
    ...aktivoMyWellness.modules,
    ...senselyWidget.modules,
    ...myPrivilegesConfig.modules,
    ...referralProgramme.modules,
    ...cmsConfig.modules,
    ...programmeRegistration.modules,
  ],
} as any;
